import Pagination from 'components/Pagination';

export const renderPagination = (pagination) =>
	pagination.total > 1 ? (
		<Pagination total={pagination.total} current={pagination.current} />
	) : null;
